import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { ADORepositoryPicker } from './ADORepositoryPicker';

export const ADORepositoryPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ADORepositoryPicker',
    component: ADORepositoryPicker,
  }),
);
